import { ProgCss } from "./ProgCss.Generated";
import { addTooltipToTarget } from "./tooltips";

export function WireUpHoverText(scopeEl: HTMLElement) {
    const boxes: HTMLElement[] = [];
    for (const box of scopeEl.getElementsByClassName(ProgCss.u_maxWidthLimited)) {
        if (box instanceof HTMLElement && box.scrollWidth > box.clientWidth) {
            boxes.push(box);
        }
    }
     // Eerst alles gefiltered en dan pas DOM mutatie om client side load te verlagen ivm reflow
    for (const box of boxes) {
        const clone = box.cloneNode(true); // clone nodig om de tooltip op te baseren
        disablePointerEventsOfChildren(box); // eerst gecloned voor pointer events disabelen
        addTooltipToTarget(box, Array.from(clone.childNodes), box.getAttribute("data-undashed") === "true", false);
    }
}

function disablePointerEventsOfChildren(target: Element) {
    for (const child of target.children) {
        if (child instanceof HTMLElement) {
            child.style.pointerEvents = "none";
        }
    }
}

